import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/landing/safety-highlight.png")